import axios from 'axios'
import { api } from '../api'
import mock from '../mocks/news' // Предполагаем, что у вас есть mock для новостей
import { createSelector } from 'reselect'

/**
 * Constants
 * */
export const moduleName = 'news'

export const START = '_START'
export const SUCCESS = '_SUCCESS'
export const ERROR = '_ERROR'

export const NEWS = `${moduleName}/NEWS`

/**
 * Reducer
 * */
const defaultState = {
	loading: false,
	loaded: false,
    error: null,
    response: null
}

export default (state = defaultState, action) => {
    const { type, response, error } = action

    switch (type) {
        case NEWS + START:
            return { 
                ...state, 
                loading: true 
        }
        case NEWS + SUCCESS:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                response: response
        }
        case NEWS + ERROR:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                error
        }
        default:
            return state
    }
}

/**
 * Action Creators
 * */
export const loadNews = (params) => async (dispatch) => {
	dispatch({ type: NEWS + START })
	try {
		const { data } = await axios.post(api + '?' + new URLSearchParams(params).toString());
		if (data) {
            dispatch({ 
                type: NEWS + SUCCESS, 
                response: data 
            })
        } else {

            dispatch({ 
                type: NEWS + SUCCESS, 
                response: mock 
            })
        }
	} catch (error) {
		console.log(error);
		// В случае ошибки также используем данные из mock
        // dispatch({ 
        //     type: NEWS + SUCCESS, 
        //     response: mock 
        // });
	}
}

export const selectNews = (state) => state.news.response;
export const selectNewsProject = createSelector(
    [
      selectNews,
      (state, news) => news
    ],
    (news, newItem) => {
        if(news) {
            return news.filter(item => item.link === newItem.link)
        }
    }
)
